export default "__VITE_ASSET__CabwCQq___"